
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import PlatformMarkerPlatMini from "../../editor/platform-markers/cave/PlatformMarkerPlatMini";
import PlatformMarkerPillar from "../../editor/platform-markers/cave/PlatformMarkerPillar";
import PlatformMarkerStack2 from "../../editor/platform-markers/cave/PlatformMarkerStack2";
import PlatformMarkerPlatMid from "../../editor/platform-markers/cave/PlatformMarkerPlatMid";
import TrapMarkerTorch from "../../editor/trap-markers/cave/TrapMarkerTorch";
import SmashableMarkerRocks from "../../editor/entity-markers/SmashableMarkerRocks";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import PlatformMarkerPlat from "../../editor/platform-markers/cave/PlatformMarkerPlat";
import PlatformMarkerStack1 from "../../editor/platform-markers/cave/PlatformMarkerStack1";
import PlatformMarkerGroundLava from "../../editor/platform-markers/cave/PlatformMarkerGroundLava";
import PlatformMarkerStack3 from "../../editor/platform-markers/cave/PlatformMarkerStack3";
import RelicMarker from "../../editor/RelicMarker";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class CaveChunkRelic1 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? -381.58257912127925, y ?? 178.22467347422582);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 233, 368);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 9104, 368);
    this.add(editor_bounds_right);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 1534, -125);
    this.add(gemMarker_12);

    // platformMarkerPlatMini
    const platformMarkerPlatMini = new PlatformMarkerPlatMini(scene, 1528, -20);
    this.add(platformMarkerPlatMini);

    // platformMarkerPillar_2
    const platformMarkerPillar_2 = new PlatformMarkerPillar(scene, 1193, 293);
    this.add(platformMarkerPillar_2);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 488, 131);
    this.add(gemMarker_5);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 365, 134);
    this.add(gemMarker_6);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 628, 134);
    this.add(gemMarker_7);

    // platformMarkerStack_2
    const platformMarkerStack_2 = new PlatformMarkerStack2(scene, 304, 307);
    this.add(platformMarkerStack_2);

    // platformMarkerStack_3
    const platformMarkerStack_3 = new PlatformMarkerStack2(scene, 676, 307);
    this.add(platformMarkerStack_3);

    // platformMarkerPlatMid_4
    const platformMarkerPlatMid_4 = new PlatformMarkerPlatMid(scene, 492, 221);
    this.add(platformMarkerPlatMid_4);

    // platformMarkerPillar_3
    const platformMarkerPillar_3 = new PlatformMarkerPillar(scene, 2615, 301);
    this.add(platformMarkerPillar_3);

    // trapMarkerTorch
    const trapMarkerTorch = new TrapMarkerTorch(scene, 2617, 174);
    this.add(trapMarkerTorch);

    // platformMarkerPillar_4
    const platformMarkerPillar_4 = new PlatformMarkerPillar(scene, 3921, 285);
    this.add(platformMarkerPillar_4);

    // trapMarkerTorch_1
    const trapMarkerTorch_1 = new TrapMarkerTorch(scene, 3918, 157);
    this.add(trapMarkerTorch_1);

    // platformMarkerPillar_5
    const platformMarkerPillar_5 = new PlatformMarkerPillar(scene, 4352, 284);
    this.add(platformMarkerPillar_5);

    // trapMarkerTorch_2
    const trapMarkerTorch_2 = new TrapMarkerTorch(scene, 4347, 158);
    this.add(trapMarkerTorch_2);

    // smashableMarkerRocks_1
    const smashableMarkerRocks_1 = new SmashableMarkerRocks(scene, 4556, -731);
    this.add(smashableMarkerRocks_1);

    // gemMarker_19
    const gemMarker_19 = new SmallGemMarker(scene, 2616, -653);
    this.add(gemMarker_19);

    // trapMarkerTorch_8
    const trapMarkerTorch_8 = new TrapMarkerTorch(scene, 3847, -617);
    this.add(trapMarkerTorch_8);

    // gemMarker_30
    const gemMarker_30 = new SmallGemMarker(scene, 4065, -626);
    this.add(gemMarker_30);

    // trapMarkerTorch_10
    const trapMarkerTorch_10 = new TrapMarkerTorch(scene, 2785, -619);
    this.add(trapMarkerTorch_10);

    // trapMarkerTorch_11
    const trapMarkerTorch_11 = new TrapMarkerTorch(scene, 3709, -642);
    this.add(trapMarkerTorch_11);

    // gemMarker_31
    const gemMarker_31 = new SmallGemMarker(scene, 3507, -648);
    this.add(gemMarker_31);

    // gemMarker_38
    const gemMarker_38 = new SmallGemMarker(scene, 4404, -617);
    this.add(gemMarker_38);

    // platformMarkerPlat_7
    const platformMarkerPlat_7 = new PlatformMarkerPlat(scene, 2654, -541);
    this.add(platformMarkerPlat_7);

    // platformMarkerPlat_8
    const platformMarkerPlat_8 = new PlatformMarkerPlat(scene, 3581, -563);
    this.add(platformMarkerPlat_8);

    // platformMarkerPlat_9
    const platformMarkerPlat_9 = new PlatformMarkerPlat(scene, 3968, -538);
    this.add(platformMarkerPlat_9);

    // platformMarkerPlatMini_1
    const platformMarkerPlatMini_1 = new PlatformMarkerPlatMini(scene, 1850, -213);
    this.add(platformMarkerPlatMini_1);

    // gemMarker_40
    const gemMarker_40 = new SmallGemMarker(scene, 1851, -309);
    this.add(gemMarker_40);

    // platformMarkerPlatMini_4
    const platformMarkerPlatMini_4 = new PlatformMarkerPlatMini(scene, 2189, -384);
    this.add(platformMarkerPlatMini_4);

    // gemMarker_41
    const gemMarker_41 = new SmallGemMarker(scene, 2193, -494);
    this.add(gemMarker_41);

    // platformMarkerStack_8
    const platformMarkerStack_8 = new PlatformMarkerStack1(scene, 2356, 313);
    this.add(platformMarkerStack_8);

    // platformMarkerStack_4
    const platformMarkerStack_4 = new PlatformMarkerStack2(scene, 4544, 297);
    this.add(platformMarkerStack_4);

    // platformMarkerStack_5
    const platformMarkerStack_5 = new PlatformMarkerStack2(scene, 4916, 297);
    this.add(platformMarkerStack_5);

    // platformMarkerPlatMid_5
    const platformMarkerPlatMid_5 = new PlatformMarkerPlatMid(scene, 4732, 211);
    this.add(platformMarkerPlatMid_5);

    // platformMarkerPillar
    const platformMarkerPillar = new PlatformMarkerPillar(scene, 4139, 285);
    this.add(platformMarkerPillar);

    // platformMarkerGroundLava
    const platformMarkerGroundLava = new PlatformMarkerGroundLava(scene, 3465, 322);
    this.add(platformMarkerGroundLava);

    // platformMarkerStack_11
    const platformMarkerStack_11 = new PlatformMarkerStack1(scene, 5281, 309);
    this.add(platformMarkerStack_11);

    // platformMarkerStack_10
    const platformMarkerStack_10 = new PlatformMarkerStack1(scene, 5206, 309);
    this.add(platformMarkerStack_10);

    // platformMarkerStack_9
    const platformMarkerStack_9 = new PlatformMarkerStack1(scene, 5761, 310);
    this.add(platformMarkerStack_9);

    // platformMarkerStack_14
    const platformMarkerStack_14 = new PlatformMarkerStack1(scene, 6190, 307);
    this.add(platformMarkerStack_14);

    // platformMarkerStack_12
    const platformMarkerStack_12 = new PlatformMarkerStack3(scene, 8499, 288);
    this.add(platformMarkerStack_12);

    // platformMarkerStack_13
    const platformMarkerStack_13 = new PlatformMarkerStack3(scene, 8850, 284);
    this.add(platformMarkerStack_13);

    // platformMarkerPlatMid_2
    const platformMarkerPlatMid_2 = new PlatformMarkerPlatMid(scene, 8676, 174);
    this.add(platformMarkerPlatMid_2);

    // platformMarkerPillar_1
    const platformMarkerPillar_1 = new PlatformMarkerPillar(scene, 5483, 266);
    this.add(platformMarkerPillar_1);

    // trapMarkerTorch_3
    const trapMarkerTorch_3 = new TrapMarkerTorch(scene, 5478, 140);
    this.add(trapMarkerTorch_3);

    // platformMarkerStack_16
    const platformMarkerStack_16 = new PlatformMarkerStack1(scene, 2910, 315);
    this.add(platformMarkerStack_16);

    // platformMarkerStack_17
    const platformMarkerStack_17 = new PlatformMarkerStack1(scene, 2984, 315);
    this.add(platformMarkerStack_17);

    // platformMarkerPlat
    const platformMarkerPlat = new PlatformMarkerPlat(scene, 4535, -526);
    this.add(platformMarkerPlat);

    // platformMarkerPlat_1
    const platformMarkerPlat_1 = new PlatformMarkerPlat(scene, 4604, -924);
    this.add(platformMarkerPlat_1);

    // platformMarkerPillar_6
    const platformMarkerPillar_6 = new PlatformMarkerPillar(scene, 6503, 287);
    this.add(platformMarkerPillar_6);

    // trapMarkerTorch_6
    const trapMarkerTorch_6 = new TrapMarkerTorch(scene, 6498, 161);
    this.add(trapMarkerTorch_6);

    // trapMarkerTorch_14
    const trapMarkerTorch_14 = new TrapMarkerTorch(scene, 4608, -1005);
    this.add(trapMarkerTorch_14);

    // gemMarker_28
    const gemMarker_28 = new SmallGemMarker(scene, 8674, 43);
    this.add(gemMarker_28);

    // gemMarker_29
    const gemMarker_29 = new SmallGemMarker(scene, 8538, 46);
    this.add(gemMarker_29);

    // gemMarker_32
    const gemMarker_32 = new SmallGemMarker(scene, 8801, 46);
    this.add(gemMarker_32);

    // smashableMarkerRocks
    const smashableMarkerRocks = new SmashableMarkerRocks(scene, 6226, -710);
    this.add(smashableMarkerRocks);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 6074, -596);
    this.add(gemMarker);

    // platformMarkerPlat_2
    const platformMarkerPlat_2 = new PlatformMarkerPlat(scene, 6205, -505);
    this.add(platformMarkerPlat_2);

    // platformMarkerPlat_3
    const platformMarkerPlat_3 = new PlatformMarkerPlat(scene, 6209, -903);
    this.add(platformMarkerPlat_3);

    // trapMarkerTorch_5
    const trapMarkerTorch_5 = new TrapMarkerTorch(scene, 6213, -984);
    this.add(trapMarkerTorch_5);

    // platformMarkerStack_18
    const platformMarkerStack_18 = new PlatformMarkerPlatMini(scene, 4966, -494);
    this.add(platformMarkerStack_18);

    // platformMarkerStack_19
    const platformMarkerStack_19 = new PlatformMarkerPlatMini(scene, 5787, -476);
    this.add(platformMarkerStack_19);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 4963, -631);
    this.add(gemMarker_9);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 5355, -658);
    this.add(gemMarker_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 5792, -613);
    this.add(gemMarker_11);

    // platformMarkerStack_20
    const platformMarkerStack_20 = new PlatformMarkerPlatMini(scene, 5353, -517);
    this.add(platformMarkerStack_20);

    // trapMarkerTorch_16
    const trapMarkerTorch_16 = new TrapMarkerTorch(scene, 5190, -522);
    this.add(trapMarkerTorch_16);

    // platformMarkerPlatMini_2
    const platformMarkerPlatMini_2 = new PlatformMarkerPlatMini(scene, 3081, -645);
    this.add(platformMarkerPlatMini_2);

    // platformMarkerPlatMini_5
    const platformMarkerPlatMini_5 = new PlatformMarkerPlatMini(scene, 3158, -645);
    this.add(platformMarkerPlatMini_5);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 6710, -622);
    this.add(gemMarker_14);

    // trapMarkerTorch_17
    const trapMarkerTorch_17 = new TrapMarkerTorch(scene, 7042, -366);
    this.add(trapMarkerTorch_17);

    // trapMarkerTorch_18
    const trapMarkerTorch_18 = new TrapMarkerTorch(scene, 7449, -360);
    this.add(trapMarkerTorch_18);

    // platformMarkerPlat_4
    const platformMarkerPlat_4 = new PlatformMarkerPlat(scene, 7318, -282);
    this.add(platformMarkerPlat_4);

    // platformMarkerPlatMini_3
    const platformMarkerPlatMini_3 = new PlatformMarkerPlatMini(scene, 7038, -276);
    this.add(platformMarkerPlatMini_3);

    // platformMarkerPlatMini_6
    const platformMarkerPlatMini_6 = new PlatformMarkerPlatMini(scene, 6712, -518);
    this.add(platformMarkerPlatMini_6);

    // relicMarker
    const relicMarker = new RelicMarker(scene, 7942, -368);
    this.add(relicMarker);

    // platformMarkerStack_6
    const platformMarkerStack_6 = new PlatformMarkerStack1(scene, 6811, 311);
    this.add(platformMarkerStack_6);

    // platformMarkerStack_7
    const platformMarkerStack_7 = new PlatformMarkerStack1(scene, 7209, 313);
    this.add(platformMarkerStack_7);

    // platformMarkerPillar_8
    const platformMarkerPillar_8 = new PlatformMarkerPillar(scene, 7494, 298);
    this.add(platformMarkerPillar_8);

    // trapMarkerTorch_20
    const trapMarkerTorch_20 = new TrapMarkerTorch(scene, 7489, 172);
    this.add(trapMarkerTorch_20);

    // platformMarkerPillar_9
    const platformMarkerPillar_9 = new PlatformMarkerPillar(scene, 8370, 310);
    this.add(platformMarkerPillar_9);

    // trapMarkerTorch_21
    const trapMarkerTorch_21 = new TrapMarkerTorch(scene, 8365, 184);
    this.add(trapMarkerTorch_21);

    // platformMarkerPlatMid
    const platformMarkerPlatMid = new PlatformMarkerPlatMid(scene, 7955, -293);
    this.add(platformMarkerPlatMid);

    // platformMarkerGroundLava_2
    const platformMarkerGroundLava_2 = new PlatformMarkerGroundLava(scene, 7921, 328);
    this.add(platformMarkerGroundLava_2);

    // platformMarkerPlat_6
    const platformMarkerPlat_6 = new PlatformMarkerPlat(scene, 7939, -24);
    this.add(platformMarkerPlat_6);

    // trapMarkerTorch_25
    const trapMarkerTorch_25 = new TrapMarkerTorch(scene, 7819, -111);
    this.add(trapMarkerTorch_25);

    // trapMarkerTorch_26
    const trapMarkerTorch_26 = new TrapMarkerTorch(scene, 7943, -105);
    this.add(trapMarkerTorch_26);

    // platformMarkerStack_21
    const platformMarkerStack_21 = new PlatformMarkerPlatMini(scene, 5188, -435);
    this.add(platformMarkerStack_21);

    // trapMarkerTorch_22
    const trapMarkerTorch_22 = new TrapMarkerTorch(scene, 5535, -513);
    this.add(trapMarkerTorch_22);

    // platformMarkerStack_22
    const platformMarkerStack_22 = new PlatformMarkerPlatMini(scene, 5532, -426);
    this.add(platformMarkerStack_22);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 350, 184);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 4602, 164);
    this.add(checkpointMarker_1);

    // platformMarkerStack_1
    const platformMarkerStack_1 = new PlatformMarkerStack1(scene, 6732, 311);
    this.add(platformMarkerStack_1);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 1883, -270);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 1828, -268);
    this.add(gemMarker_2);

    // platformMarkerStack
    const platformMarkerStack = new PlatformMarkerStack1(scene, 1966, 319);
    this.add(platformMarkerStack);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 1178, 145);
    this.add(gemMarker_3);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 1210, 184);
    this.add(gemMarker_4);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 1155, 186);
    this.add(gemMarker_13);

    // gemMarker_18
    const gemMarker_18 = new SmallGemMarker(scene, 3102, -716);
    this.add(gemMarker_18);

    // gemMarker_21
    const gemMarker_21 = new SmallGemMarker(scene, 3155, -758);
    this.add(gemMarker_21);

    // gemMarker_22
    const gemMarker_22 = new SmallGemMarker(scene, 3100, -792);
    this.add(gemMarker_22);

    // gemMarker_23
    const gemMarker_23 = new SmallGemMarker(scene, 4676, -603);
    this.add(gemMarker_23);

    // gemMarker_35
    const gemMarker_35 = new SmallGemMarker(scene, 4729, -645);
    this.add(gemMarker_35);

    // gemMarker_36
    const gemMarker_36 = new SmallGemMarker(scene, 4674, -679);
    this.add(gemMarker_36);

    // gemMarker_37
    const gemMarker_37 = new SmallGemMarker(scene, 6361, -579);
    this.add(gemMarker_37);

    // gemMarker_39
    const gemMarker_39 = new SmallGemMarker(scene, 6414, -621);
    this.add(gemMarker_39);

    // gemMarker_42
    const gemMarker_42 = new SmallGemMarker(scene, 6359, -655);
    this.add(gemMarker_42);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 7240, -359);
    this.add(gemMarker_8);

    // gemMarker_15
    const gemMarker_15 = new SmallGemMarker(scene, 7293, -401);
    this.add(gemMarker_15);

    // gemMarker_16
    const gemMarker_16 = new SmallGemMarker(scene, 7238, -435);
    this.add(gemMarker_16);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // smashableMarkerRocks_1 (components)
    const smashableMarkerRocks_1SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_1);
    smashableMarkerRocks_1SimpleBreakableBlocker.allowedCharacter = "grizz";

    // smashableMarkerRocks (components)
    const smashableMarkerRocksSimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks);
    smashableMarkerRocksSimpleBreakableBlocker.allowedCharacter = "grizz";

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
